import React from 'react';
import { Modal, ModalBody, ModalHeader, Box, Flex, Text, Spinner, } from '@spothero/ui';
import { ReviewItem } from './ReviewItem';
import { ReviewTooltip } from 'common/spot-details/reviews/ReviewTooltip';
export const ReviewsModal = ({ isOpen, onClose, reviews, isLoading, error, hasMore, sentinelRef, }) => {
    return (<Modal isOpen={isOpen} onClose={onClose} hasHeader hasFooter={false} isMobile data-testid="ReviewsModal">
            <ModalHeader>
                Reviews
                <Flex gap={1} marginTop={3}>
                    <Text fontSize="sm" fontWeight="semibold">
                        Reservation Details
                    </Text>
                    <ReviewTooltip ariaLabel="Reservation Details">
                        View reservation details for each rating, including
                        duration, vehicle type, and whether it was for an event.
                        Sorted by most recent review created date.
                    </ReviewTooltip>
                </Flex>
            </ModalHeader>
            <ModalBody>
                <Box overflowY="auto" width="100%">
                    <Flex flexDirection="column" gap={3}>
                        {reviews.map(review => (<ReviewItem key={review.id} review={review}/>))}
                    </Flex>
                    {error && (<Text color="red.500" textAlign="center" paddingY={4}>
                            {error}
                        </Text>)}
                    {isLoading && (<Flex justifyContent="center" paddingY={4}>
                            <Spinner />
                        </Flex>)}
                    {!isLoading && !error && reviews.length === 0 && (<Text textAlign="center" paddingY={4} color="gray.500">
                            No reviews available.
                        </Text>)}
                    {hasMore && !isLoading && !error && (<Box ref={sentinelRef} height="1px"/>)}
                </Box>
            </ModalBody>
        </Modal>);
};
